import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import iziToast from "izitoast";
import { useDispatch } from "react-redux";
import { companyAdminLoginApi } from "actions/companyActions";
import { setUserTokenAction } from "../redux/userSlice";
import { clearCart as clearReduxCart } from "../redux/cartSlice";
import { useAuth } from "AuthContext";

const CompanyAdminLoginPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { clearCartDetailItems, setToken } = useAuth();

  const authenticateCompanyAdmin = async () => {
    try {
      const token = new URLSearchParams(window.location.search).get("token");
      console.log(token);
      const response = await companyAdminLoginApi({ token });
      console.log("authenticateCompanyAdmin response", { response });

      if (response.status) {
        iziToast.success({
          title: "Success",
          message: response.message,
          position: "topCenter",
        });
        localStorage.setItem("token", response.data?.token);
        dispatch(setUserTokenAction({ user: response.data?.user, token: response.data?.token }));
        setToken(response.data?.token);

        // Reset detail items + redux cart; the persisted cart will be fetched
        // for the impersonated company by AuthProvider's token effect.
        clearCartDetailItems();
        dispatch(clearReduxCart());

        navigate("/dashboard");
      } else {
        iziToast.error({
          title: "Error",
          message: response.message,
          position: "topCenter",
        });
      }
    } catch (error) {}
  };

  useEffect(() => {
    authenticateCompanyAdmin();
  }, [navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-s360-app">
      <div className="h-2 w-full max-w-xs overflow-hidden rounded-full bg-s360-bg2">
        <div className="progress-bar-fill block h-full w-1/4 rounded-full bg-s360-violet" />
      </div>
      <p className="text-sm text-s360-fg3">Redirecting...</p>
    </div>
  );
};

export default CompanyAdminLoginPage;
